<template>
  <div class="wapper">
    <el-page-header @back="goBack" :content="info.id == null ? '新增折算业绩与提成方案' : '修改折算业绩与提成方案'" class="header">
    </el-page-header>
    <div class="content-wapper">
      <el-form :model="info" :rules="rules" ref="ruleForm" label-width="180px" style="width:1000px;">
        <el-form-item label="折算业绩与提成方案名称" prop="planName">
          <el-input placeholder="请输入折算业绩与提成方案名称" v-model="info.planName" class="input-width"></el-input>
        </el-form-item>
        <el-form-item label="预算范围折算业绩系数" prop="budgetConversionFactor">
          <el-input placeholder="请输入预算范围折算业绩系数" v-model="info.budgetConversionFactor" class="input-width" @change="budgetConversionFactorChange">
            <template slot="append">%</template>
          </el-input>
          <p class="notes">注：该系数不参与计算提成，仅用于折算业绩，比如臻享E。需输入大于等于0且小于等于100的数值，当销售按本提成方案下单时将使用该系数折算业绩</p>
        </el-form-item>
        <el-form-item label="适用应用规则是否参与折算" prop="flagPaltform">
          <el-radio-group v-model="info.flagPaltform" @change="flagPaltformChange">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
          <div class="performanceRuleList-wapper" v-if="info.flagPaltform == 1">
            <div>
              <el-radio-group v-model="info.platformMatchType">
                <el-radio :label="1">满足以下任意条件之一</el-radio>
                <el-radio :label="2">同时满足以下所有条件</el-radio>
              </el-radio-group>
            </div>
            <div class="performanceRuleList-con">
              <div class="per-con-til">
                <p style="width: 98px;"></p>
                <p style="width: 70px;"> <span class="item-error">*</span>关系 </p>
                <p style="width: 200px;"> <span class="item-error">*</span>供应应用平台 </p>
                <p style="width: 215px;"> <span class="item-error">*</span>应用规则 </p>
                <p style="width: 44px;"></p>
              </div>
              <div>
                <div class="performanceRuleList-item" v-for="(item, index) in performanceRuleList" :key="index">
                  <span>条件：应用规则</span>
                  <div>
                    <el-select v-model="item.relationType" :disabled="true" style="width: 70px;">
                      <el-option :label="'包含'" :value="'1'"></el-option>
                      <el-option :label="'不包含'" :value="'0'"></el-option>
                    </el-select>
                  </div>
                  <el-select placeholder="请选择应用平台" v-model="item.platformCode" style="width: 200px;"
                    @change="platformCodeChange($event, index)">
                    <el-option v-for="appitem in appPlatformList" :key="appitem.platformCode"
                      :label="appitem.platformName" :value="`${appitem.platformCode}`">
                    </el-option>
                  </el-select>

                  <div class="cards-template-item">
                    <el-select placeholder="请选择或者搜索名称" filterable v-model="item.appRuleCode" @change="appRuleCodeChange($event,item, index)" :remote="item.platformCode=='NEIGOU_SHOPING'?true: false" :remote-method="(query)=>remoteMethod(query, index)">
                      <el-option v-for="ruleitem in item.ruleList" :key="ruleitem.ruleId" :label="ruleitem.ruleName"
                        :value="`${ruleitem.ruleId}`">
                      </el-option>
                    </el-select>
                  </div>
                  <div class="performanceRuleList-item-btn">
                    <el-button type="text" @click="removePerformanceRule(index)" v-show="index != 0">删除</el-button>
                  </div>
                </div>
                <el-button type="text" style="width: 100%;" size="small" @click="addPerformanceRule">增加1个条件</el-button>
              </div>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="适用应用规则折算业绩系数" prop="performanceRuleFactor" v-if="info.flagPaltform == 1">
          <el-input v-model="info.performanceRuleFactor" class="input-width" placeholder="请输入适用应用规则折算业绩系数"
            @change="performanceRuleFactorChange">
            <template slot="append">%</template>
          </el-input>
          <div class="notes">注：需输入大于等于0且小于等于100的数值，并设置上方的条件，当销售下单满足上方条件时将按照你填入的系数折算业绩，不满足时不折算</div>
        </el-form-item>
        <el-form-item>
          <template slot="label">
            <span class="item-error">*</span>
            <span>有效期折算业绩系数</span>
          </template>
          <div class="notes" style="height: 40px; display: flex;align-items: center;">
            注：设置有效期区间和每个区间对应的折算业绩系数，月数为自然数，系数大于等于0且小于等于100，销售下单时将按照该区间折算业绩
          </div>
        </el-form-item>
        <div class="table-wapper coefficient-table">
          <table class="table-title coefficient-table-inner">
            <colgroup>
              <col class="c-type">
              <col class="c-term">
              <col class="c-rate">
              <col class="c-op">
            </colgroup>
            <thead>
              <tr>
                <td colspan="4">
                  有效期折算业绩系数
                  <a href="javascript:void(0);" @click="addValidityCoefficient">添加区间</a>
                </td>
              </tr>
              <tr style="text-align:left;font-weight: normal;">
                <td>类型</td>
                <td>有效期</td>
                <td>有效期折算业绩系数</td>
                <td>操作</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, idx) in conversionValidityList" :key="idx">
                <td>有效期区间</td>
                <td :class="fieldErrorClass(idx, 'months')">
                  <input type="text" v-model.number="row.minMonth"> 个月(含) ~
                  <input type="text" v-model.number="row.maxMonth"> 个月(不含)
                </td>
                <td :class="fieldErrorClass(idx, 'coefficient')">
                  <input type="text" v-model.number="row.coefficient"> %
                </td>
                <td>
                  <a href="javascript:void(0);" class="remove" @click="removeValidityCoefficient(idx)">删除</a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <el-form-item label="经理审批线" prop="managerLine">
          <el-input v-model="info.managerLine" class="input-width">
            <template slot="append">元</template>
          </el-input>
          <div class="notes">注：需输入大于0的数值，当销售实际单点售价 &lt; 该界线值时，订单需经理审批。</div>
        </el-form-item>
        <el-form-item label="总监审批线" prop="directorLine">
          <el-input class="input-width" v-model="info.directorLine">
            <template slot="append">元</template>
          </el-input>
          <div class="notes">注：需输入大于0的数值，当销售实际单点售价 &lt; 该界线值时，订单需总监审批。</div>
        </el-form-item>
        <el-form-item label="折算业绩线" prop="conversionLine">
          <el-input class="input-width" v-model="info.conversionLine">
            <template slot="append">元</template>
          </el-input>
          <div class="notes">注：需输入大于0的数值，当销售实际单点售价 < 该界线值时，按照预先配置的审批流，由设置好的审批人审批。</div>
        </el-form-item>
        <el-form-item label="禁止销售线" prop="saleLine">
          <el-input class="input-width" v-model="info.saleLine">
            <template slot="append">元</template>
          </el-input>
          <div class="notes">注：需输入大于0的数值，当销售实际单点售价 &lt; 该界线值时，系统提醒销售需要走特殊审批流程。</div>
        </el-form-item>
        <el-form-item label="提成计算方式" prop="conditionMethod">
          <el-radio-group v-model="info.conditionMethod" @change="packageTypeChange">
            <el-radio :label="1">条件区间</el-radio>
            <el-radio :label="2">条件选项</el-radio>
          </el-radio-group>
        </el-form-item>
        <div v-if="info.conditionMethod == 1" class="notes" style="padding-left:150px;">
          注：提成方案至少需要一个销售金额大于0的提成方案，否则将可能无法创建订单。
        </div>
        <div class="table-wapper" v-if="info.conditionMethod == 1">
          <table class="table-title">
            <colgroup>
              <col width="80">
              <col width="200">
              <col width="80">
              <col width="80">
              <col width="80">
              <col width="100">
              <col width="50">
            </colgroup>
            <tr>
              <td colspan="7">
                售价折算业绩及提成方案表
                <a href="javascript:void(0);" @click="addPlanTable">新增方案</a>
              </td>
            </tr>
            <tr style="text-align:left;font-weight: normal;">
              <td>类型</td>
              <td>实际售价</td>
              <td>销售提成</td>
              <td>经理提成</td>
              <td>总监提成</td>
              <td>售价折算业绩系数</td>
              <td>操作</td>
            </tr>
          </table>
          <table v-for="(plan, planIndex) in royaltyPlans" :key="planIndex" class="data-table">
            <colgroup>
              <col width="80">
              <col width="200">
              <col width="80">
              <col width="80">
              <col width="80">
              <col width="100">
              <col width="50">
            </colgroup>
            <tr>
              <td colspan="7">
                <span ref="plan-item-salesAmount">
                  销售总金额大于
                  <input :disabled="planIndex == 0" type="text" style="width:112px;" v-model.number="plan.salesAmount">
                  元
                </span>
                <a v-if="planIndex > 0" href="javascript:void(0);" @click="removePlanTable(planIndex)"
                  style="right:80px;" class="remove">删除方案</a>
                <a href="javascript:void(0);" @click="addPlan(planIndex)">添加区间</a>
              </td>
            </tr>
            <tr v-for="(item, index) in plan.list" :key="index">
              <td>{{ item.isSection == 1 ? "区间售价" : "标准售价" }}</td>
              <!-- 标准售价 -->
              <td v-if="item.isSection == 2" :ref="refName(planIndex, 'lowestPrice')">
                <input type="text" v-model.number="item.lowestPrice" @change="lowestPriceChange(item)">元
              </td>
              <!-- 区间售价 -->
              <td v-else :ref="refName(planIndex, 'lowestPrice')">
                <input type="text" v-model.number="item.lowestPrice">元(含) ~ <input type="text"
                  v-model.number="item.maximumPrice">元(不含)
              </td>
              <td :ref="refName(planIndex, 'saleRoyalty')">
                <input type="text" v-model.number="item.saleRoyalty">%
              </td>
              <td :ref="refName(planIndex, 'managerRoyalty')">
                <input type="text" v-model.number="item.managerRoyalty">%
              </td>
              <td :ref="refName(planIndex, 'directorRoyalty')">
                <input type="text" v-model.number="item.directorRoyalty">%
              </td>
              <td :ref="refName(planIndex, 'saleConversionFactor')">
                <input type="text" v-model.number="item.saleConversionFactor">%
              </td>
              <td>
                <a v-if="index < (plan.list.length - 2)" href="javascript:void(0);"
                  @click="removePlan(planIndex, index)" class="remove">删除</a>
              </td>
            </tr>
          </table>
        </div>
        <div v-if="info.conditionMethod == 2">
          <p v-if="id" class="item-error m-label">特别注意：如果你增加、移除或修改了下方的条件并提交方案，请务必第一时间联系运营告知调整了哪些内容，并要求运营检查应用了该方案的子模板是否正确选择了下方这些条件，否则销售在CRM选择这些子模板后可能无法下单；以下场景同样视为修改：先移除某条件，然后再增加一个条件名称、系数完全相同的条件</p>
          <OptionList ref="optionListRef" :optionList.sync="optionList" />
        </div>
        <el-form-item prop="flagPackage" v-if="info.conditionMethod == 1">
          <template slot="label">
            <span class="item-error">*</span>
            <span>是否对“销售提成”乘以系数</span>
          </template>
          <el-radio-group v-model="info.flagPackage">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
          <Annotation content="臻享S、超级生活卡以及与其他需要乘以系数的选“是”，其他选“否”，该系数仅对销售提成生效， 不影响销经理与总监的佣金" />
          <div class="package-wapper" v-if="info.flagPackage == 1">
            <p class="m-b-10">此位置填写的条件将出现在“新增/编辑子模板”页，作为提成系数的选项供运营单选，销售下单选中模板将自动显示对应的提成</p>
            <p v-if="id" class="item-error">特别注意：如果你增加、移除或修改了下方的字段和条件并提交方案，请务必第一时间联系运营告知调整了哪些内容，并要求运营检查应用了该方案的子模板是否正确选择了下方这些条件，否则销售在CRM选择这些子模板后可能无法下单；以下场景同样视为修改：先移除某字段，然后再增加一个字段名称、条件、系数完全相同的字段。</p>
            <div v-for="(item, index) in packageList" :key="index" class="package">
              <div class="package-header">
                <div>
                  <span> <span class="item-error">*</span> 字段名称</span>
                  <el-input v-model="item.fieldName" placeholder="请输入字段名称" style="width: 200px;"></el-input>
                </div>
                <el-button type="text" @click="removePackage(index)" v-if="index != 0">移除本字段</el-button>
              </div>
              <div class="package-content">
                <p>
                  <span> <span class="item-error">*</span> 条件（运营在创建模板时可单选其中之一）</span>
                  <span> <span class="item-error">*</span> 销售提成系数（该系数不影响经理和总监佣金）</span>
                </p>
                <div v-for="(planPckage, planPckageIndex) in item.planPckageList" :key="planPckageIndex"
                  class="package-content-item">
                  <el-input v-model="planPckage.fieldName" placeholder="请输入条件" style="width: 250px;">
                  </el-input>=
                  <!-- 限制0-100 且小数点后两位 -->
                   <div>
                     <el-input v-model="planPckage.fieldConfig" placeholder="请输入条件配置" :disabled="planPckageIndex == 0" @input="fieldConfigChange($event,planPckage)"
                       style="width: 250px;" >
                       <template slot="append">%</template>
                     </el-input>
                     <el-button v-if="planPckageIndex != 0" type="text" @click="removePackageField(index,planPckageIndex)">移除本选项</el-button>
                     <div v-else class="hideQuickly"></div>
                   </div>
                </div>
              </div>
              <div class="add-package-field">
                <el-button type="text" @click="addPackage(index)">添加1个条件</el-button>
              </div>
            </div>
            <div class="add-package-field">
              <el-button type="text" @click="addPackageField">增加1个字段</el-button>
            </div>
            <div class="item-error">
              填写说明：销售人员的最终提成 = 销售折算业绩及提成方案表中的销售提成 × 字段1被选中的条件对应的销售提成系数 × 字段2被选中的条件对应的销售提成系数 × ……
            </div>
          </div>
        </el-form-item>
        <el-form-item prop="allSaleFlag">
          <template slot="label">
            <span>定制归属人-全部销售开关</span>
          </template>
          <el-radio-group v-model="info.allSaleFlag">
            <el-radio :label="0">关闭</el-radio>
            <el-radio :label="1">开启</el-radio>
          </el-radio-group>
          <Annotation content="如果选中“开启”，运营选择该方案创建子模板时，可自主选择是否将“定制归属人”设为“全部销售”；选“关闭”则不向运营提供该功能。折算业绩功能上线前，运营选择臻享B（id:32）、臻享C（id:33）、电影悦享卡（id34）创建子模板时允许将“定制归属人”设为全部销售，其他预算范围不允许。" />
        </el-form-item>
        <el-form-item prop="invoiceList">
          <template slot="label">
            <span>可开发票内容</span>
          </template>
          <div class="label-title">请在以下列表中选择该提成方案下对应模板的可开的发票内容</div>
          <div class="i-content-wapper">
            <div class="i-content-query">
              <el-input placeholder="请输入发票内容名称或关键字" v-model="contentName" style="width:300px;"></el-input>
              <el-button size="small" @click="getInvoiceListByName">查询</el-button>
            </div>
            <el-table :data="invoiceContents" @select="tableSelect" @select-all="tableSelect" ref="invoiceContents">
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column prop="name" label="发票内容名称"></el-table-column>
            </el-table>
          </div>
          <div class="notes">注：建议模板和提成方案进行一对一关联设置。</div>
        </el-form-item>
        <el-form-item label="备注" prop="remarks">
          <el-input type="textarea" v-model="info.remarks" class="textarea-width" placeholder="请输入提成方案备注信息说明字" rows="5"
            resize="none"></el-input>
        </el-form-item>
      </el-form>
      <div class="button-wapper">
        <el-button size="small" type="primary" @click="dialogVisible = true">提交</el-button>
      </div>
    </div>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
      <span>{{ id?'提交成功后将按当前的设置更新方案，是否确认提交？':'是否确认提交？' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import _constant from '@/utils/constant'
import _royaltyPlan from '@/service/royalty-plan-service'
import _pointsPlan from '@/service/points-plan-service'
import _invoiceContent from '@/service/invoice-content-service'
import schema from 'async-validator'
import OptionList from './common/optionList.vue'
export default {
  components: {
    OptionList
  },
  data() {
    return {
      dialogVisible: false,
      id: this.$route.query.id,
      info: {
        planName: null,
        conditionMethod: null,
        budgetConversionFactor: 100,
        conditionMethod: 1,
        platformMatchType: 1,
        performanceRuleFactor: null,
        managerLine: null,
        directorLine: null,
        conversionLine: null,
        saleLine: null,
        royaltySpecialValue: null,
        flagPaltform: 0,
        flagPackage: 0,
        remarks: null,
        invoiceList: [],
        allSaleFlag:0 //0:关闭，1:开启
      },
      performanceRuleList: [],
      optionList: {
        fieldName: null, // 字段名称
        conditions: [   // 条件列表
          {
            optionName: null,      // 选项名称
            saleRoyalty: null,     // 销售提成%
            managerRoyalty: null,  // 经理管理佣金%
            directorRoyalty: null  // 总监管理佣金%
          }
        ]
      },
      royaltyPlans: [
        {
          salesAmount: 0,
          list: [
            {
              // 1=区间售价，2=标准售价
              isSection: 1,
              lowestPrice: null,
              maximumPrice: null,
              saleRoyalty: null,
              managerRoyalty: null,
              directorRoyalty: null,
              saleConversionFactor: null,
            },
            {
              // 1=区间售价，2=标准售价
              isSection: 2,
              lowestPrice: null,
              maximumPrice: null,
              saleRoyalty: null,
              managerRoyalty: null,
              directorRoyalty: null,
              saleConversionFactor: null,
            }
          ]
        }
      ],
      appPlatformList: [],
      conversionValidityList: [],
      validityCoefficientErrors: {},
      packageList: [
        {
          fieldName: null,
          planPckageList: [
            {
              fieldName: null,
              fieldConfig: 100, //第一行的“100%”为只读，不可修改，文字提示：必须包含此系数
            }
          ]
        }
      ],
      // 发票内容
      invoiceContents: [],
      contentName: null,
      rules: {
        allSaleFlag: [
          { required: true, message: '请选择定制归属人-全部销售开关', trigger: 'blur' },
          { required: true, message: '请选择定制归属人-全部销售开关', trigger: 'change' },
        ],
        planName: [
          { required: true, message: '请输入折算业绩与提成方案名称', trigger: 'blur' },
          { max: 32, message: '提成方案名称最大32个字符', trigger: 'blur' },
        ],
        budgetConversionFactor: [
          { required: true, message: '请输入预算范围折算业绩系数', trigger: 'blur' },
          { pattern: /^\d+(\.\d{1,2})?$/, message: '预算范围折算业绩系数必须为数字最多保留两位小数', trigger: 'blur' },
        ],
        flagPaltform: [
          { required: true, message: '请选择适用应用规则是否参与折算', trigger: 'blur' },
          { required: true, message: '请选择适用应用规则是否参与折算', trigger: 'change' },
        ],
        performanceRuleFactor: [
          { required: true, message: '请输入适用应用规则折算业绩系数', trigger: 'blur' },
          { pattern: /^\d+(\.\d{1,2})?$/, message: '适用应用规则折算业绩系数必须为数字最多保留两位小数', trigger: 'blur' }
        ],
        managerLine: [
          { pattern: /^\d+(\.\d{1,2})?$/, message: '经理审批线必须为数字最多保留两位小数', trigger: 'blur' },
        ],
        directorLine: [
          { pattern: /^\d+(\.\d{1,2})?$/, message: '总监审批线必须为数字最多保留两位小数', trigger: 'blur' },
        ],
        conversionLine: [
          { pattern: /^\d+(\.\d{1,2})?$/, message: '折算业绩线必须为数字最多保留两位小数', trigger: 'blur' },
        ],
        saleLine: [
          { pattern: /^\d+(\.\d{1,2})?$/, message: '禁止销售线必须为数字最多保留两位小数', trigger: 'blur' },
        ],
        conditionMethod: [
          { required: true, message: '请选择提成计算方式', trigger: 'blur' },
          { required: true, message: '请选择提成计算方式', trigger: 'change' },
        ],
        invoiceList: [
          { required: true, message: '请选择发票内容', trigger: 'submit' }
        ]
      },
      salesAmountRule: {
        salesAmount: {
          pattern: /^\d+(\.\d{1,2})?$/,
          required: true,
        }
      },
      royaltyPlanRule: {
        lowestPrice: {
          pattern: /^\d+(\.\d{1,2})?$/,
          required: true,
        },
        maximumPrice: {
          pattern: /^\d+(\.\d{1,2})?$/,
          required: true,
        },
        saleRoyalty: {
          pattern: /^\d+(\.\d{1,3})?$/,
          required: true,
        },
        managerRoyalty: {
          pattern: /^\d+(\.\d{1,3})?$/,
          required: true,
        },
        directorRoyalty: {
          pattern: /^\d+(\.\d{1,3})?$/,
          required: true,
        },
        saleConversionFactor: {
          pattern: /^\d+(\.\d{1,3})?$/,
          required: true,
        },
      },
    }
  },
  mounted() {
    if (this.id != null) {
      this.getInfo()
    } else {
      this.addValidityCoefficient()
      this.addPerformanceRule()
    }
    this.getAppPlatformList()
    this.getInvoiceListByName()
  },
  methods: {
    getInvoiceListByName(callBack) {
      this.invoiceContents = null
      _invoiceContent.getInvoiceListByName(this.contentName, response => {
        this.invoiceContents = response
        typeof callBack === 'function' && callBack()
      })
    },
    // 表格多选事件
    tableSelect(selection) {
      this.info.invoiceList = []
      selection.forEach(item => {
        this.info.invoiceList.push({
          invoiceContentId: item.id
        })
      })
    },
    goBack() {
      this.$router.back()
    },
    getInfo() {
      _pointsPlan.pointsPlanDetalis(this.id, response => {
        this.info = response
        if(this.info.planSales&&this.info.planSales.length>0){
          this.royaltyPlans = this.info.planSales
        } else {
          this.addPlanTable()
        }
        if (this.info.conversionValidityList) {
          this.conversionValidityList = this.info.conversionValidityList.map(item => ({
            minMonth: item.minMonth,
            maxMonth: item.maxMonth,
            coefficient: item.coefficient
          }))
        }
        if (this.info.performanceRuleList) {
          this.performanceRuleList = this.info.performanceRuleList
            this.getAppPlatformList()
        }
        // 加载条件选项数据
        if (this.info.optionsMap) {
          this.optionList = {
            fieldName: null,
            conditions: []
          }
          for (const item in this.info.optionsMap) {
            this.optionList.fieldName = item
            this.info.optionsMap[item].forEach(row=>{
              this.optionList.conditions.push(row)
            })
          }
        }
        if (this.info.packageList) {
          this.packageList = this.info.packageList
        }
        this.getInvoiceListByName(() => {
          // 等待表格渲染完成后再回显选中状态
          this.$nextTick(() => {
            // 选中已选发票内容
            for (const content of this.invoiceContents) {
              for (const item of this.info.invoiceList) {
                if (item.invoiceContentId == content.id) {
                  this.$refs.invoiceContents.toggleRowSelection(content)
                }
              }
            }
          })
        })
      }, err => {
        this.$notify({ message: err, type: 'warning' })
      })
    },
    addPerformanceRule() {
      this.performanceRuleList.push({
        platformCode: null,
        appRuleCode: null,
        appRuleName: null,
        platformName: null,
        relationType: '1',
        ruleList: [],
      })
    },
    flagPaltformChange() {
      console.log(this.performanceRuleList);

    },
    performanceRuleFactorChange() {
      if (this.info.performanceRuleFactor > 100) {
        this.$set(this.info, 'performanceRuleFactor', 100)
      }
    },
    budgetConversionFactorChange() {
      if (this.info.budgetConversionFactor > 100) {
        this.$set(this.info, 'budgetConversionFactor', 100)
      }
    },
    addValidityCoefficient() {
      this.conversionValidityList.unshift({ minMonth: null, maxMonth: null, coefficient: null })
    },
    removeValidityCoefficient(idx) {
      this.conversionValidityList.splice(idx, 1)
    },
    fieldErrorClass(idx, field) {
      return this.validityCoefficientErrors[`${idx}-${field}`] ? 'item-error' : ''
    },
    getAppRuleList() {
      this.performanceRuleList.forEach((item, index) => {
        if (item.platformCode) {
          this.getRuleListByPlatform('', index)
        }
      })
    },
    getRuleListByPlatform(query, index) {
      if (this.performanceRuleList[index].platformCode != null) {
        this.appPlatformList.forEach(item => {
          if (item.platformCode == this.performanceRuleList[index].platformCode) {
            var code_url = '';
            if (item.ruleCodeUrl.includes('getBrandList')) {
              code_url = item.ruleCodeUrl;
            } else {
              code_url = item.ruleCodeUrl + '&name=' + query;
            }
            _royaltyPlan.getRuleListByPlatform(code_url, response => {
              this.$set(this.performanceRuleList[index], 'ruleList', response)
              this.$forceUpdate()
            })
            return
          }
        })

      } else {
        this.ruleList = null
      }
    },
    platformCodeChange(e, index) {
      this.appPlatformList.forEach(item=>{
        if(item.platformCode==e){
          this.performanceRuleList[index].platformName = item.platformName
        }
      })

      if (e != 'NEIGOU_SHOPING') {
        this.getRuleListByPlatform('', index);
      }

      this.performanceRuleList[index].ruleList = [];
      this.performanceRuleList[index].appRuleCode = '';
    },
    appRuleCodeChange(e,item,index){
      item.ruleList.forEach(row=>{
        if(row.ruleId==e){
          this.performanceRuleList[index].appRuleName = row.ruleName
        }
      })
    },

    // 查询应用平台
    getAppPlatformList() {
      _royaltyPlan.getAppPlatformList(res => {
        this.appPlatformList = res
        this.getAppRuleList()
      })
    },
    removePerformanceRule(index) {
      this.performanceRuleList.splice(index, 1)
    },
    addPlan(index) {
      this.royaltyPlans[index].list.unshift(
        {
          // 1=区间售价，2=标准售价
          isSection: 1,
          lowestPrice: null,
          maximumPrice: null,
          saleRoyalty: null,
          managerRoyalty: null,
          directorRoyalty: null,
          saleConversionFactor: null,
        }
      )
    },
    addPlanTable() {
      this.royaltyPlans.push(
        {
          salesAmount: null,
          list: [
            {
              // 1=区间售价，2=标准售价
              isSection: 2,
              lowestPrice: null,
              maximumPrice: null,
              saleRoyalty: null,
              managerRoyalty: null,
              directorRoyalty: null,
              saleConversionFactor: null,
            },
            {
              // 1=区间售价，2=标准售价
              isSection: 1,
              lowestPrice: null,
              maximumPrice: null,
              saleRoyalty: null,
              managerRoyalty: null,
              directorRoyalty: null,
              saleConversionFactor: null,
            }
          ]
        }
      )
    },
    // 删除方案
    removePlanTable(planIndex) {
      this.royaltyPlans.splice(planIndex, 1)
    },
    // 删除规则
    removePlan(planIndex, index) {
      this.royaltyPlans[planIndex].list.splice(index, 1)
    },
    refName(planIndex, name) {
      return 'plan-item' + planIndex + '-' + name
    },
    lowestPriceChange(item) {
      item.maximumPrice = item.lowestPrice
    },
    packageTypeChange() {
      if (this.info.conditionMethod == 2) {
        this.info.flagPackage = 0
        if(this.optionList.conditions.length==0){
          this.$refs.optionListRef.addCondition()
        }
      }
    },
    addPackage(index) {
      this.packageList[index].planPckageList.push({
        fieldName: null,
        fieldConfig: null,
      })
    },
    addPackageField() {
      this.packageList.push({
        fieldName: null,
        planPckageList: [
          {
            fieldName: null,
            fieldConfig: 100,
          }
        ],
      })
    },
    removePackage(index) {
      this.packageList.splice(index, 1)
    },
    submit() {
      this.dialogVisible = false
      this.$refs.ruleForm.validate((valid) => {
        //适用应用规则是否参与折算
        if (!this.performanceRuleValidate()) {
          return false
        } else {
          this.info.performanceRuleList = this.performanceRuleList
        }
        if (this.validateValidityCoefficientList()) {
          this.info.conversionValidityList = this.conversionValidityList
        } else {
          return false
        }
        if (!valid) {
          this.$notify({ message: '有必填项未填写，请检查后再提交', type: 'warning' })
          return false
        }
        // 条件区间
        if (this.info.conditionMethod == 1) {
          if (!this.royaltyPlansVal()) {
            this.$notify({ message: '提成计算方式-条件区间存在未填写项，请检查后再提交', type: 'warning' })
            return false
          } else {
            this.info.planSales = this.royaltyPlans
            //是否对“销售提成”乘以系数
            if (this.info.flagPackage == 1) {
              if (!this.flagPackageVal()) {
                return false
              } else {
                this.info.packageList = this.packageList
                this.info.optionList=null
              }
            }
          }
        }
        // 条件选项
        if (this.info.conditionMethod == 2) {
          if (!this.conditionMethod2Val()) {
            return false
          } else {
            let optionlist = this.$refs.optionListRef.localData.conditions.map(item=>{
              return {...item,name:this.$refs.optionListRef.localData.fieldName}
            })
            this.info.optionList = optionlist
            this.info.packageList=null
            this.info.flagPackage=0
          }
        }
        if(this.info.flagPaltform==0){
          this.info.performanceRuleList = []
        }
        // 调用接口
        let _loading = this.$loading({ fullscreen: true })
        _pointsPlan.pointsPlanAddOrEdit(this.info, res => {
          _loading.close()
          this.$notify({ message: '创建成功', type: 'success' })
          this.$router.push({
            path: '/points-plan-detail',
            query: {
              id: res,
              status: 1
            }
          })
        }, err => {
          _loading.close()
          this.dialogVisible = false
          this.$notify({ message: err, type: 'warning' })
        })
      })
    },
    flagPackageVal() {
      // 条件名称不能为空 改成for 循环判断
      for (let i = 0; i < this.packageList.length; i++) {
        if (!this.packageList[i].fieldName) {
          this.$notify({ message: '是否对“销售提成”乘以系数的条件名称不能为空', type: 'warning' })
          return false
        }
      }
      for (let i = 0; i < this.packageList.length; i++) {
        for (let j = 0; j < this.packageList[i].planPckageList.length; j++) {
          if (!this.packageList[i].planPckageList[j].fieldConfig) {
            this.$notify({ message: '销售提成系数不能为空', type: 'warning' })
            return false
          }
          //条件（运营在创建模板时可单选其中之一） b=不能为空
          if (!this.packageList[i].planPckageList[j].fieldName) {
            this.$notify({ message: '条件（运营在创建模板时可单选其中之一）不能为空', type: 'warning' })
            return false
          }
        }
      }
      return true
    },
    conditionMethod2Val() {
      // 调用 OptionList 组件的校验方法
      if (this.$refs.optionListRef) {
        return this.$refs.optionListRef.validate()
      }
      return true
    },
    royaltyPlansVal() {
      var isPlans = true
      var isSalesAmount = true
      var validator = new schema(this.royaltyPlanRule)
      var saValidator = new schema(this.salesAmountRule)
      this.royaltyPlans.forEach((plan, planIndex) => {
        saValidator.validate(plan, (errors) => {
          if (errors != null) {
            isPlans = false
            errors.forEach(() => {
              this.$refs['plan-item-salesAmount'][planIndex].className = 'item-error'
            })
          }
        })
        // 清除原有样式
        this.$refs[this.refName(planIndex, 'lowestPrice')].forEach(el => {
          el.className = ''
        })
        this.$refs[this.refName(planIndex, 'saleRoyalty')].forEach(el => {
          el.className = ''
        })
        this.$refs[this.refName(planIndex, 'managerRoyalty')].forEach(el => {
          el.className = ''
        })
        this.$refs[this.refName(planIndex, 'directorRoyalty')].forEach(el => {
          el.className = ''
        })
        this.$refs[this.refName(planIndex, 'saleConversionFactor')].forEach(el => {
          el.className = ''
        })
        plan.list.forEach((item, index) => {
          validator.validate(item, (errors) => {
            if (errors != null) {
              isSalesAmount = false
              errors.forEach(error => {
                if (error.field == 'maximumPrice') {
                  this.$refs[this.refName(planIndex, 'lowestPrice')][index].className = 'item-error'
                } else {
                  this.$refs[this.refName(planIndex, error.field)][index].className = 'item-error'
                }
              })
            }
          })
        })
      })
      return isPlans && isSalesAmount
    },
    performanceRuleValidate() {
      if (this.info.flagPaltform == 1) {
        if (this.performanceRuleList.length == 0) {
          this.$notify({ message: '请至少添加一个条件', type: 'warning' })
          return false
        }
        if (!this.performanceRuleList.every(item => item.platformCode && item.appRuleCode)) {
          this.$notify({ message: '请选择应用平台和应用规则', type: 'warning' })
          return false
        }
        //应用规则不可重复
        if (this.performanceRuleList.some(item => item.appRuleCode && this.performanceRuleList.filter(i => i.appRuleCode == item.appRuleCode).length > 1)) {
          this.$notify({ message: '应用规则不可重复', type: 'warning' })
          return false
        }
        return true
      }
      return true
    },
    normalizeValidityCoefficientList() {
      return (this.conversionValidityList || [])
        .map(item => ({
          minMonth: item.minMonth,
          maxMonth: item.maxMonth,
          coefficient: item.coefficient
        }))
        .sort((a, b) => (a.minMonth ?? 0) - (b.minMonth ?? 0))
    },
    validateValidityCoefficientList() {
      const list = this.normalizeValidityCoefficientList()
      if (!Array.isArray(list) || list.length < 1) {
        this.$notify({ message: '请至少添加一个有效期折算业绩系数区间', type: 'warning' })
        return false
      }

      const setErr = (idx, field) => {
        this.$set(this.validityCoefficientErrors, `${idx}-${field}`, true)
      }

      let ok = true
      const usedRanges = []
      for (let i = 0; i < list.length; i++) {
        const row = list[i]
        const start = row.minMonth
        const end = row.maxMonth
        const coeff = row.coefficient

        const isNatural = (n) => Number.isInteger(n) && n >= 0
        if (!isNatural(start) || !isNatural(end) || start >= end) {
          setErr(i, 'months')
          ok = false
        }
        if (!(typeof coeff === 'number') || Number.isNaN(coeff) || coeff < 0 || coeff > 100) {
          setErr(i, 'coefficient')
          ok = false
        }
        if (ok) {
          usedRanges.push({ start, end, idx: i })
        }
      }

      usedRanges.sort((a, b) => a.start - b.start)
      for (let i = 1; i < usedRanges.length; i++) {
        const prev = usedRanges[i - 1]
        const curr = usedRanges[i]
        if (curr.start < prev.end) {
          setErr(prev.idx, 'months')
          setErr(curr.idx, 'months')
          ok = false
        }
      }

      if (!ok) {
        this.$notify({ message: '有效期折算业绩系数配置有误，请检查红色标记项（区间需为自然月且不重叠，系数为0~100）', type: 'warning' })
      }
      return ok
    },
    fieldConfigChange(e,planPckage){
      let val = e.replace(/[^0-9.]/g, '')
      // 去除前导零
      val = val.replace(/^0+(?=\d)/, '')
      // 只允许一个小数点
      val = val.replace(/(\..*)\./g, '$1')
      // 最多两位小数
      val = val.replace(/(\..{2})./g, '$1')
      // 最大值限制为100
      planPckage.fieldConfig = val
    },
    removePackageField(index,planPckageIndex){
      this.packageList[index].planPckageList.splice(planPckageIndex,1)
    },
    remoteMethod(query,index){
      if (query !== '') {
        this.loading = true;
        this.getRuleListByPlatform(query,index);
      } else {
        this.performanceRuleList[index].ruleList = null
      }
    },
  },
}
</script>

<style scoped>
.wapper {
  padding: 15px;
}

.header {
  margin-bottom: 15px;
}

.content-wapper {
  border: 1px solid #d6dbe5;
  border-radius: 3px;
  padding: 15px;
  background: #fff;
}

.cards-template-wapper {
  background: #d6dbe5;
  padding: 15px;
  border-radius: 3px;
}

.cards-template-item {
  margin-right: 15px;
  display: inline-block;
}

.tips {
  font-size: 12px;
}

.selected-wapper {
  font-size: 12px;
  border-top: 1px dashed #909399;
  margin-top: 15px;
  padding-top: 15px;
}

.selected-title {
  display: inline-block;
  width: 80px;
  text-align: left;
  color: #909399;
}

.selected-name {
  display: inline-block;
  margin-right: 20px;
}

/* 始终在屏幕的下方 */
.button-wapper {
  margin-left: 180px;
  /* position: sticky; */
  /* bottom: 10px; */
  /* z-index: 1; */
  /* background-color: #fff; */
  /* padding: 10px; */
}

.button-wapper .el-button {
  width: 550px;
}

.upload-wapper {
  position: relative;
  display: inline-block;
  margin-right: 15px;
}

.upload-wapper input {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 210px;
  height: 100px;
  opacity: 0;
}

.image-slot span {
  width: 100%;
  height: 100px;
  line-height: 100px;
  text-align: center;
  vertical-align: middle;
  display: inline-block;
  font-size: 12px;
  border: 1px dashed #909399;
  border-radius: 5px;
  color: #909399;
}

.notes {
  font-size: 12px;
  color: #F56C6C;
  line-height: 17px;
}

.table-wapper {
  width: 825px;
  font-size: 12px;
  margin-left: 180px;
  margin-bottom: 30px;
  border: 1px double #909399;
  border-top: none;
  border-width: 3px;
}

.coefficient-table {
  margin-left: 170px;
}

.coefficient-table .coefficient-table-inner {
  table-layout: fixed;
}

.coefficient-table col.c-type {
  width: 160px;
}

.coefficient-table col.c-term {
  width: 280px;
}

.coefficient-table col.c-rate {
  width: 275px;
}

.coefficient-table col.c-op {
  width: 100px;
}

.table-wapper .el-radio {
  display: block;
  width: 100%;
}

.table-wapper .el-input {
  width: 50px;
}

.table-wapper table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
}

.table-wapper .table-title td {
  padding: 6px;
  border-top: 1px solid #d6dbe5;
  border-right: 1px solid #d6dbe5;
  position: relative;
  white-space: nowrap;
}

.table-wapper input {
  color: #383e43;
  width: 50px;
  text-align: center;
}

.data-table {
  border-top: none;
  position: relative;
}

.data-table td {
  padding: 6px;
  border-top: 1px solid #d6dbe5;
  border-right: 1px solid #d6dbe5;
  border-bottom: 1px solid #d6dbe5;
}

.data-table td:last-child {
  border-right: 1px solid #d6dbe5;
}

.table-wapper .table-title td:last-child {
  border-right: 1px solid #d6dbe5;
}

.table-wapper td:last-child {
  width: 50px;
  border-right: none;
}

.coefficient-table .coefficient-table-inner td:last-child {
  width: 100px;
  border-right: 1px solid #d6dbe5;
}

.table-wapper tr:first-child {
  border-top: 1px double #909399;
  border-width: 3px;
}

.table-wapper table {
  width: 100%;
}

.table-title {
  font-weight: bold;
  background: #f9f9f9;
  text-align: center;
}

.td-merge {
  border-right: none !important;
}

.table-wapper .opertion {
  background: #f9f9f9;
}

.table-wapper .el-input-number--small {
  width: 100px;
}

.table-wapper a {
  color: #409eff;
}

.table-wapper .table-title a {
  position: absolute;
  right: 10px;
}

.data-table a {
  /* position: static; */
  position: absolute;
  right: 10px;
}

.table-wapper .remove {
  color: #F56C6C;
}

.opertion-title {
  font-weight: bold;
}

input {
  border-bottom: 1px solid #DCDFE6;
}

.item-error {
  color: #F56C6C;
}

.item-error input {
  border-color: #F56C6C;
}

.input-width {
  width: 250px;
}

.performanceRuleList-wapper {
  margin-bottom: 10px;
  border: 1px solid #d6dbe5;
  border-radius: 5px;
  padding: 10px;
}

.performanceRuleList-con {
  border-top: 1px solid #d6dbe5;
  padding-top: 10px;
}

.performanceRuleList-con .per-con-til {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  margin-bottom: 10px;
}

.performanceRuleList-con .per-con-til p {
  text-align: center;
}

.performanceRuleList-item {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  margin-bottom: 22px;
}

.performanceRuleList-item-btn {
  width: 44px;
  text-align: center;
}

.package-wapper {}

.package {
  border: 1px solid #d6dbe5;
  /* padding: 10px; */
  margin-bottom: 10px;
  border-radius: 5px;
  margin-top: 12px;
}

.package-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 10px;
  border-bottom: 1px solid #d6dbe5;
}

.package-content {
  /* padding: 10px; */
}

.package-content p {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  padding: 10px 0;
}

.package-content-item {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  padding: 10px 0;
}

.add-package-field {
  text-align: center;
  margin-top: 10px;
}

.label-title {
  color: #606266;
  font-size: 12px;
  position: relative;
  margin-top: 22px;
}

.label-title::after {
  content: "*";
  color: #F56C6C;
  position: absolute;
  left: -10px;
}

.i-content-wapper {
  border: 1px solid #d6dbe5;
  border-bottom: none;
  width: 550px;
}

.i-content-query {
  padding: 15px;
}

.i-content-query .el-input {
  margin-right: 15px;
}

.info-label {
  font-size: 12px;
}

.textarea-width {
  width: 550px;
}
.hideQuickly{
  width: 85px;
  display: inline-block;
}
.m-label{
  margin-left: 170px;
  margin-bottom: 10px;
}
.m-b-10{
  margin-bottom: 10px;
}
</style>